import React from 'react';
import { XCircle } from 'lucide-react';

interface IconPodProps {
    Icon: any;
    isDueNow: boolean;
    isOverdue: boolean;
    isPlanned: boolean;
    isSkipped: boolean;
    isCompleted: boolean;
    themeColor: string;
}

export const IconPod: React.FC<IconPodProps> = ({ 
    Icon, isDueNow, isOverdue, isPlanned, isSkipped, isCompleted, themeColor 
}) => {
    return (
        <div style={{ 
            width: '42px', height: '42px', borderRadius: '12px', 
            backgroundColor: isDueNow ? `${themeColor}33` : `${themeColor}1a`, display: 'flex', 
            alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            borderWidth: '1px',
            borderStyle: isPlanned && !isDueNow && !isOverdue ? 'dashed' : 'solid',
            borderColor: isOverdue ? '#ef444433' : `${themeColor}33`,
            boxShadow: isDueNow ? `0 0 15px ${themeColor}33` : `0 0 15px ${themeColor}11`
        }}>
            {isSkipped ? (
                <XCircle size={20} color="#666" />
            ) : (
                <Icon 
                    size={22} 
                    color={isOverdue ? '#ef4444' : themeColor} 
                    fill={isCompleted || isDueNow ? themeColor : 'transparent'} 
                    style={{ opacity: isCompleted ? 0.3 : 1 }} 
                />
            )}
        </div>
    );
};
